import api from '@/service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function request(fileName: string, apiKey: string, params?: any): any {  
  return new Promise((resolve, reject) => {
    api[`${fileName}`][`${apiKey}`](params).then((res: any) => resolve(res)).catch((err: any) => reject(err));
  });
}